<app-data-list-forgiveness [data]="data" [title]="title" [columns]="displayedColumns"></app-data-list-forgiveness>